import Button from 'components/Button'
import React, {useEffect, useCallback, useRef} from 'react'

import { style, Container } from './ArPreview.style'
import {QRCodeSVG} from 'qrcode.react';

const Spinner = () => <div className="loader"></div>;

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}


const ArPreview = ({
  className,
  ar,
  pendingRequest,
  error,
  step,
  json,
  url
}) => {
  
  var buttonRef = useRef(null);
 
  /** @param {Event} e */
  function openInAr(){
 
    if(buttonRef.current){

      var file_url_glb = ar['glb'];
      var file_url_usdz = ar['usdz'];
      var href = `intent://arvr.google.com/scene-viewer/1.0?file=${file_url_glb}&mode=ar_only#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`
      if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        href = `${file_url_usdz}#allowsContentScaling=0`;
      }
      buttonRef.current.href = href;
    }
    
  }

  useEffect(() => {
    openInAr();
  });
  
    

  return (
    <Container className={className} style={style}>
        <div className="headerTitle">See it in AR</div>
        {!isMobile() && 
          <p>To visualize this chair in your room, simply scan this QR code using your smartphone camera. Please use a spacious room for optimal performance.</p>
        }
        {isMobile() && 
          <p>To visualise this chair in your room, simply tap the button below. Please use a spacious room for optimal performance.</p>
        }
        {url && <QRCodeSVG className="onlyDesktop" value={url} /> }
        { pendingRequest ? <Spinner />:'' }
        {error && <div className="error">{error}</div>}
        {url && (
        <a rel="ar" ref={buttonRef} href="#" className="button-ar block onlyMobile">
          <img style={{display:'none'}} alt="" />
          <div className="button">
            Preview in AR 
            <img className="button-ar__image" src={require('../../img/ar.png')} alt="" />
          </div>
        </a>
        )}
    </Container>
  )
}

export default ArPreview
